<div *ngIf="datasetProducerType" class="no-data-to-view" noDataToView>
  <capra-icon icon="illo-no-result-table" title="No data to view" data-test="no-data-to-view"></capra-icon>
  <ng-container *ngIf="!isNotebookCellDataset; else notebookCellTemplate">
    <h4 class="big-and-bold">There’s no data to view</h4>
    <p>This usually happens when the source Dataset doesn’t return any results</p>
    <a *ngIf="datasetViewUrl" [href]="datasetViewUrl" target="_blank">Go to source Dataset</a>
  </ng-container>
</div>
<ng-template #notebookCellTemplate>
  <div class="no-data-message">
    <h4 class="big-and-bold">There’s no data to view. This can happen when:</h4>
    <ol>
      <li>The source output or data it references doesn’t return any results</li>
      <li>The source output doesn't produce a pandas.DataFrame</li>
    </ol>
  </div>
  <a *ngIf="notebookViewUrl" [href]="notebookViewUrl" target="_self">Go to Notebook</a>
</ng-template>
